import { jsxs as _jsxs, jsx as _jsx } from "@emotion/react/jsx-runtime";
import { WEIGHT_BOLD } from "@hl/base-components/lib/theme/typography";
import { Text } from "@mantine/core";
import CollectionActivity from "../activity/CollectionActivity";
export const ActivityModalHeader = ({ tokenName, collectionName, }) => (_jsxs(Text, { fw: WEIGHT_BOLD, children: ["View activity for ", tokenName, " \u00B7 ", collectionName] }));
const ActivityModal = ({ collectionData, tokenId, isImported, }) => {
    if (!collectionData.id) {
        return null;
    }
    return (_jsx(CollectionActivity, { collection: collectionData, isInModal: true, tokenId: tokenId, disableChart: true, isImported: isImported }));
};
export default ActivityModal;
